<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-3">
        <ArtistSelect
          @memberChangeEvent="getArtistInfo"
          :is-filter="true"
          :show-members="false"
          :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
        />
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <base-button class="update-button" @click.prevent="goPhotoCardForm()" type="success">포토카드 추가</base-button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-1">아이디</div>
      <div class="col-sm-3">제목</div>
      <div class="col-sm-3">경로</div>
      <div class="col-sm-1"></div>
      <div class="col-sm-3"></div>
    </div>
    <hr />
    <div
      class="row template-table"
      v-for="(item, index) in data"
      :style="{
        backgroundColor: item.isVisible === 0 ? '#d3d3d3' : 'white' /* 연한 회색 */,
        borderBottom: '1px solid #ccc' /* 각 row에 경계선 추가 */,
        padding: '10px 0' /* row 사이에 여백 추가 */,
      }"
    >
      <div class="col-sm-1">{{ item.id }}</div>
      <div class="col-sm-3">{{ item.title }}</div>
      <div class="col-sm-3">{{ item.path | photoCardPath }}</div>
      <div class="col-sm-1"><base-button @click.native="copyUrl(item.path)" type="warning" size="sm"> 복사 </base-button></div>
      <div class="col-sm-3">
        <base-button @click.native="goPhotoCardForm(item.id)" type="warning" size="sm"> 수정 </base-button>
        <base-button @click.native="removeWebPage(item.id)" type="warning" size="sm"> 삭제 </base-button>
        <base-button @click.native="sendPhotoCard(item.id, item.title)" type="warning" size="sm"> 포토카드부여 </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BasePagination } from "@/components";
import Endpoints from "@/common/Endpoints";
import { Alert } from "@/util/Alert";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import swal from "sweetalert2";

export default {
  components: {
    ArtistSelect,
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getData();
  },
  watch: {
    currentPage: {
      handler() {
        this.getData(this.currentPage);
      },
    },
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;

      await this.getData();
    },
    async getData() {
      const res = await this.$axios.get(`/quests/photoCards?unitId=${this.unitId}`);
      this.data = res.data.data;
    },

    async goPhotoCardForm(id) {
      if (id) {
        await this.$router.push(`/quest/photoCardForm?id=${id}&unitId=${this.unitId}`);
      } else {
        await this.$router.push(`/quest/photoCardForm?unitId=${this.unitId}`);
      }
    },

    copyUrl(path) {
      const url = `${Endpoints.homepageUrl}/mission/photocard/${path}`;
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = url;
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      window.Toast.success("클립보드에 주소가 복사되었습니다");
    },

    async removeWebPage(id) {
      if (await Alert.dangerousConfirmCancel("삭제하시겠습니까?")) {
        await this.$axios.delete(`/quests/photoCards/${id}`);
        Toast.success("삭제되었습니다");
        await this.getData();
      }
    },
    async sendPhotoCard(id, title) {
      swal
        .fire({
          title: `유저에게 ${title} 포토카드 부여`,
          html: `
                    <textarea class="form-control" id="userIds" rows="3" ></textarea>
                     <div>
                     <input type="text" id="titleKo" class="swal2-input" placeholder="알림타이틀(한국어)">
        <input type="text" id="bodyKo" class="swal2-input" placeholder="알림내용(한국어)">
        <input type="text" id="titleEn" class="swal2-input" placeholder="알림타이틀(영어)">
        <input type="text" id="bodyEn" class="swal2-input" placeholder="알림내용(영어)">
        <input type="text" id="titleJa" class="swal2-input" placeholder="알림타이틀(일본어)">
        <input type="text" id="bodyJa" class="swal2-input" placeholder="알림내용(일본어)">
        </div>
    `,
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "전송",
          cancelButtonText: "취소",
          buttonsStyling: false,
          preConfirm: () => {
            // 입력값을 가져와서 객체로 반환
            const userIds = document.getElementById("userIds").value;
            if (!userIds) {
              swal.showValidationMessage("모든 입력값을 채워주세요.");
              return false;
            }
            const titleKo = document.getElementById("titleKo").value;
            const bodyKo = document.getElementById("bodyKo").value;
            const titleEn = document.getElementById("titleEn").value;
            const bodyEn = document.getElementById("bodyEn").value;
            const titleJa = document.getElementById("titleJa").value;
            const bodyJa = document.getElementById("bodyJa").value;

            if (!titleKo || !bodyKo || !titleEn || !bodyEn || !titleJa || !bodyJa) {
              swal.showValidationMessage("모든 입력값을 채워주세요.");
              return false;
            }

            return { userIds, titleKo, bodyKo, titleEn, bodyEn, titleJa, bodyJa };
          },
        })
        .then(async (result) => {
          console.log(result);
          if (result.isConfirmed) {
            try {
              return this.$axios
                .put(`/quests/photoCards/${id}/sendPhotoCard`, {
                  unitId: this.unitId,
                  userIds: result.value.userIds.trim(),
                  ...result.value,
                })
                .then((res) => {
                  Toast.success("전송완료");
                });
            } catch (err) {
              Toast.error("전송 중 에러가 발생하였습니다.");
            }
          }
        });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
